const DomElementMixin = {
    props: {
        w: 100,
        h: 100,
        pX: 0,
        pY: 0,
        pZ: 0,
        s: 1,
        r: 0,
        rX: 0,
        v: true,
        o: 1,
        align: 'center',
    },

    onBeforeSetup() {
        this.el = document.createElement('div');
    },

    setAlign(align) {
        this.el.style.position = 'absolute';

        switch (align) {
            case 'left':
                this.el.style.top = '0';
                this.el.style.left = '0';
                break;

            case 'center':
            default:
                this.el.style.top = '50%';
                this.el.style.left = '50%';
                break;
        }
    },

    setW(w) {
        if (w !== 0) {
            // this.el.style.width = w + '%';
            this.el.style.width = `${w}px`;
        }
        this.setTransform();
    },

    setH(h) {
        if (h !== 0) {
            this.el.style.height = `${h}px`;
        }
        this.setTransform();
    },

    setPX() {
        this.setTransform();
    },

    setPY() {
        this.setTransform();
    },

    setPZ() {
        this.setTransform();
    },

    setS() {
        this.setTransform();
    },

    setR() {
        this.setTransform();
    },

    setRX() {
        this.setTransform();
    },

    setTransform() {
        const { w, h, pX, pY, pZ, s, r, rX } = this.props;
        // this.el.style.webkitTransform = `translate3d(${pX - w / 2}px, ${
        //     -pY - h / 2
        // }px, 0) scale(${s}, ${s}) rotate(${r}deg)`;
        // this.el.style.transform = `translate3d(${pX - w / 2}px, ${
        //     -pY - h / 2
        // }px, 0) scale(${s}, ${s}) rotate(${r}deg)`;

        const offsetx = this.props.align === 'left' ? 0 : w / 2;
        const offsety = this.props.align === 'left' ? 0 : h / 2;
        this.el.style.transform = `translate3d(${pX - offsetx}px, ${
            -pY - offsety
        }px, ${pZ}px) scale3d(${s}, ${s}, ${s}) rotateX(${rX}deg) rotateY(0deg) rotateZ(${r}deg)`;

        // this.el.style.webkitTransform =
        //     'translate3d(' +
        //     (pX - offsetx) +
        //     'px, ' +
        //     (-pY - offsety) +
        //     'px, 0) scale(' +
        //     s +
        //     ',  ' +
        //     s +
        //     ') rotate( ' +
        //     r +
        //     'deg)';
    },

    setV(v) {
        this.el.style.visibility = v ? 'visible' : 'hidden';
    },

    setO(o) {
        this.el.style.opacity = o;
    },
};

export default DomElementMixin;
